const INPUT_TYPES = {
    TEXT: "text",
    AUDIO: "audio",
}
export default INPUT_TYPES;
